import i18n from 'modules/core/lib/i18n'

import { BUSINESS_VARIANT, ENTERPRISE_VARIANT } from 'modules/upsell/lib/selfUpsell/plans/utils'

type VariantType = typeof BUSINESS_VARIANT | typeof ENTERPRISE_VARIANT | null

interface InstalledStatusResult {
  label: string
  variant: 'positive' | 'neutral'
}

export const getInstalledStatus = (
  isInstalled: boolean,
  variant: VariantType | string,
  hasEnterpriseVariant: boolean
): InstalledStatusResult => {
  // If is installed and variant is business, return business
  if (isInstalled && variant === BUSINESS_VARIANT) {
    return {
      label: 'Business',
      variant: 'positive',
    }
  }

  // If is installed and variant is enterprise and has enterprise variant, return enterprise
  if (isInstalled && variant === ENTERPRISE_VARIANT && hasEnterpriseVariant) {
    return {
      label: 'Enterprise',
      variant: 'positive',
    }
  }
  // If is installed with the enterprise variant but no enterprise variant is
  // sellable for this module, fall back to "Business" — we can only sell the
  // Business tier for this module, but the customer does have it.
  if (isInstalled && variant === ENTERPRISE_VARIANT && !hasEnterpriseVariant) {
    return {
      label: 'Business',
      variant: 'positive',
    }
  }

  if (isInstalled) {
    return {
      label: i18n.t('marketplace.revamp.in_your_plan'),
      variant: 'positive',
    }
  }

  return {
    label: i18n.t('marketplace.revamp.not_in_your_plan'),
    variant: 'neutral',
  }
}
